<template>
  <div class="flash-element" :class="{ 'flash-element--active': isActive }" @click="highlight">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FlashElement',

  props: {
    isBlocked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isActive: false,
    }
  },

  methods: {
    highlight() {
      if (!this.isBlocked) {
        this.isActive = true
        setTimeout(() => {
          this.isActive = false
        }, On.TransitionTimes.fast)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.flash-element {
  width: 100%;

  &--active {
    opacity: 0.3;
  }
}
</style>
